import { render, staticRenderFns } from "./ProjectTestModeBar.vue?vue&type=template&id=1397c099"
import script from "./ProjectTestModeBar.vue?vue&type=script&lang=js"
export * from "./ProjectTestModeBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports